import './assets/App.css';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Lotto from './components/Lotto';

function App() {
  const isLotto = window.location.pathname === '/lotto';
  return (
    <div className="App">
      <Navigation/>
      {isLotto ? <Lotto/> : <Home/>}
    </div>
  );
}

export default App;
